// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv[data-v-bea49244] {\n  color: #151515 !important;\n}\n.otp-form input[data-v-bea49244] {\n  width: 30px;\n  height: 85px;\n  padding: 0px !important;\n  font-size: 3rem;\n  text-align: center;\n  background-color: var(--bluey-grey-5);\n  border: 1px solid var(--bluey-grey-25);\n  border-radius: 10px;\n}\n.opt-resend-info[data-v-bea49244] {\n  color: var(--bluey-grey);\n}\n.resendOtp-link[data-v-bea49244] {\n  color: var(--sea);\n}\n", ""]);
// Exports
module.exports = exports;
